import React from 'react';

import PropTypes from 'prop-types';

import { getValidChildrenCount } from '@adsk/alloy-react-helpers';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

export type NoAutocompleteResultsProps =
  StylableComponent<HTMLParagraphElement>;

const NoAutocompleteResults = ({
  className,
  style,
  children,
  ...props
}: NoAutocompleteResultsProps) => {
  const { t } = useTranslation();
  const { tokens } = useTheme();
  const noResultsTokens = tokens?.component.dropdown?.menu?.noResults;
  const text = getValidChildrenCount(children) > 0 ? children : t('NO_RESULTS');

  return (
    <li
      // role="option" is required for valid listbox children
      // aria-disabled prevents selection of "No results" message
      role="option"
      aria-disabled="true"
      aria-selected="false"
    >
      <p
        data-testid="Dropdown__noResults"
        className={className}
        css={[noResultsTokens?._, style]}
        {...props}
      >
        {text}
      </p>
    </li>
  );
};

NoAutocompleteResults.displayName = 'NoAutocompleteResults';

NoAutocompleteResults.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Override for no results content */
  children: PropTypes.any,
};

export default NoAutocompleteResults;
